export default __webpack_public_path__ + "static/media/gn.53c4258f.svg";